import { Message } from "../../classes"

const MessageModule = {
  namespaced: true,
  state: {
  },
  mutations: {
  },  
  actions: {
    createMessage: async ({ commit }, payload) => {
      const data = await Message.createMessage(payload);
      return data;
    },
    getMessages: async ({ commit }, payload) => {
      const data = await Message.getMessages(payload);
      return data;
    },
  },
  getters: {
  },
};
export default MessageModule;
